<template lang="html">
    <v-app id="inspire inspire--white">
        <v-main>
            <v-container fluid  class="container--gray container--padding">
                <v-layout align-center justify-center>
                    <div class="login-wrap">
                        <div class="login-wrap__data">
                            <div class="logo"></div>

                            <v-form
                                    align="center"
                                    v-on:submit.prevent="userLogin()"
                            >
                                <h1 class="h1--login">Progresguru Admin</h1>
                                <p class="p--login">Pro přihlášení do administrace<br class="br-from-500">je potřeba vyplnit přihlašovací údaje.</p>
                                <label>
                                    <span class="label-item">E-mail</span>
                                    <v-text-field
                                            class="input--login"
                                            :error-messages="errors.email"
                                            outlined
                                            v-model="email"
                                    ></v-text-field>
                                </label>
                                <div class="password-eye-wrap">
                                    <label>
                                        <span class="label-item">Heslo</span>
                                        <v-text-field
                                                class="input--login"
                                                :error-messages="errors.password"
                                                outlined
                                                :type="passwordType"
                                                v-model="password"
                                        ></v-text-field>
                                    </label>

                                    <span class="password-eye" v-bind:class="{'password-eye--closed': passwordType === 'password'}" @click="changePasswordType()"></span>
                                </div>

                                <div class="left">
                                    <v-btn
                                            color="secondary"
                                            type="submit"
                                            class="button--login "
                                    >Přihlásit se</v-btn>
                                </div>


                                <p class="warn-text" v-if="errorMessage">{{errorMessage}}</p>

                            </v-form>
                        </div>

                    </div>
                </v-layout>
            </v-container>


        </v-main>
    </v-app>
</template>


<script>


    export default {
        name: 'Login',
        components: {

        },



        data() {
            return {
                forgotPassword: false,
                email:'',
                password:'',
                errorMessage: '',
                errors: {
                    email: '',
                    password: ''
                },
                passwordType: 'password'
            }
        },

        created() {


        },
        computed: {


        },
        methods: {
            changePasswordType(){
                if(this.passwordType === 'password') {
                    this.passwordType = 'text';
                } else{
                    this.passwordType = 'password';
                }
            },

            userLogin(){
                // this.$router.push({'name':'Dashboard'});

                const data = {
                    'email': this.email,
                    'password': this.password
                };


                this.$axios.post('/login/admin',data).then((response) => {
                    console.log(response);
                    localStorage.setItem('token', response.data.access_token);
                    console.log(localStorage.getItem('token'))
                    this.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
                    this.$store.dispatch('getUserProfile');
                    this.$router.push({'name':'Dashboard'});

                }).catch((e) => {

                    if(e.response.data.status === 'user_not_exists'){
                        this.errors.email = 'Email není přiřazen k žádnému ůčtu!';
                    }else if(e.response.data.status === 'invalid_login'){
                        this.errors.password = 'Heslo není správné!';
                    }else if(e.response.data.status === 'user_not_confirmed'){
                        this.errors.email = 'Uživatel není potvrzen!';
                    }else if(e.response.data.status === 'user_not_admin'){
                        this.errorMessage = 'Při přihlašování nastala chyba!';
                    }else{
                        this.errorMessage = 'Při přihlašování nastala chyba!';
                    }
                });

            },



        },
        watch: {
            email(){
                this.errors.email = '';
                this.errorMessage = '';
            },
            password(){
                this.errors.password = '';
                this.errorMessage = '';
            }
        }
    }
</script>


<style lang="scss">


</style>
